import React from 'react'

import { useIntl } from 'react-intl'

import { useRecoilValue, useRecoilCallback } from 'recoil'

import { MessageBox } from 'mailup-web-components'

import { modalSendingSegmentationState } from '../../recoil/state/modals'

import { sendingSegmentationSimulateCallback } from '../../recoil/callbacks/callbacks'

const SegmentationInfo = () => {
  const intl = useIntl()

  const {
    queued,
    simulationEnabled,
    simulationLoading,
    simulationLoaded,
    simulationResult,
    simulationDiff
  } = useRecoilValue(modalSendingSegmentationState)

  const handleSimulate = useRecoilCallback(
    sendingSegmentationSimulateCallback,
    []
  )

  return (
    <MessageBox variant='info' className='modal-segmentation__info'>
      <div className='l-section'>
        {intl.formatMessage({ id: 'Load.ModalSegmentation.Info' })}
      </div>

      {simulationEnabled && (
        <div className='l-section'>
          <table className='modal-segmentation__info__table'>
            <thead>
              <tr>
                <th>
                  {intl.formatMessage({
                    id: 'Load.ModalSegmentation.RecipientsSelected'
                  })}
                </th>
                <th>
                  {intl.formatMessage({
                    id: 'Load.ModalSegmentation.RecipientsSameConditions'
                  })}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {intl.formatNumber(queued)}{' '}
                  {intl.formatMessage({ id: 'Load.Common.SubscribersLower' })}
                </td>
                <td>
                  {simulationLoading && <p className='is-loading' />}
                  {!simulationLoading && (
                    <>
                      {!simulationLoaded && (
                        <p>
                          <a
                            data-mu-test='modalSegmentation-calculate-click'
                            href='#'
                            onClick={handleSimulate}
                          >
                            {intl.formatMessage({
                              id: 'Load.ModalSegmentation.Calculate'
                            })}
                          </a>
                        </p>
                      )}

                      {simulationLoaded && (
                        <>
                          {simulationDiff === 0 && (
                            <p>
                              {intl.formatMessage({
                                id: 'Load.ModalSegmentation.NoDiff'
                              })}
                            </p>
                          )}

                          {simulationDiff !== 0 && (
                            <>
                              <p>{intl.formatNumber(simulationResult)}</p>
                              <p>
                                {simulationDiff > 0 && '+ '}
                                {simulationDiff < 0 && '- '}
                                {intl.formatNumber(simulationDiff, {
                                  signDisplay: 'never'
                                })}{' '}
                                {intl.formatMessage({
                                  id: 'Load.Common.SubscribersLower'
                                })}
                              </p>
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </MessageBox>
  )
}

export default SegmentationInfo
